import {
  OrderByDir,
  RegistrationRoleEnum,
  ResourceFragment,
  useHomeRegistrationsQuery
} from "../../../api/generated"
import { usePasteResource } from "../../../home/design/PasteResource"
// import PathCard from "../pathCard/PathCard"
import AddPathPromptCard from "./AddPathPromptCard"
import useOnPathCopied from "./useOnPathCopied"

// For copying a path via clipboard.
function InnerCopyPathPromptCard() {
  const { clip, onCancel, mutation, loading, data } = usePasteResource({
    create_registration_with_role: RegistrationRoleEnum.Editor
  })

  const clipResource = clip?.data?.resource as ResourceFragment | undefined
  const copiedResource = data?.copyResource

  const registrationsQuery = useHomeRegistrationsQuery({
    variables: {
      first: 1,
      orderBy: { created: OrderByDir.Desc }
    },
    skip: !copiedResource,
    // Network-only to ensure we get the registration created from the copied resource,
    // and not from some previous cache state. But not "no-cache" so the registration
    // can be written to the cache for useOnPathCopied.
    fetchPolicy: "network-only"
  })

  // The registration most recently created (which should be the one created
  // from copying the resource). Ideally we'd query more directly, but we don't
  // have the GQL schema/query support for that yet.
  const copierRegistration =
    registrationsQuery.data?.me?.registrations?.edges?.[0]?.node || null

  // Passing onCancel for cleanup to clear clipboard when done.
  useOnPathCopied(copierRegistration, onCancel)

  // Consider submitting when mutation loading or we have the copied resource, in which case,
  // we're awaiting the created registration to appear in the query.
  const isSubmitting = Boolean(loading || copiedResource)

  return (
    <AddPathPromptCard
      item={{
        pathName: clipResource?.name || clip?.object_label || "",
        pathBackground: clipResource
      }}
      isSubmitting={isSubmitting}
      onSubmit={async () => {
        await mutation()
      }}
      onCancel={onCancel}
    />
  )
}

// Wrapping in order to unmount the useMutation hook after clip successfully copied,
// so we can reset state if user copies again.
function CopyPathPromptCard() {
  const { enabled } = usePasteResource()

  return enabled ? <InnerCopyPathPromptCard /> : null
}

export default CopyPathPromptCard
